var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgFace = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Face",
    className: "cls-1",
    d: "M324,400a50,50,0,1,0,50,50A50,50,0,0,0,324,400Zm350,0a50,50,0,1,0,50,50A50,50,0,0,0,674,400ZM625,662.5A37.61,37.61,0,0,0,587.5,625h-175A37.61,37.61,0,0,0,375,662.5h0V675c0,27.614,55.964,50,125,50s125-22.386,125-50V662.5h0ZM500,75C265.279,75,75,265.279,75,500S265.279,925,500,925,925,734.721,925,500,734.721,75,500,75Zm0,800c-207.107,0-375-167.893-375-375S292.893,125,500,125,875,292.893,875,500,707.107,875,500,875Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFace, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Face.1b86e0ce.svg";
export { ForwardRef as ReactComponent };